export const translations = {
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      services: 'Serviços',
      products: 'Produtos',
      team: 'Equipa',
      technology: 'Tecnologia',
      groupRequest: 'Pedido de Grupos',
      contact: 'Contacto',
      agencies: 'Agências'
    },
    hero: {
      title: 'O seu Operador para Portugal e Costas Espanholas',
      subtitle: 'Operador turístico especializado em criar experiências de viagem memoráveis para agências de viagens.',
      cta: 'Pedir Orçamento',
      ctaSecondary: 'Conhecer Serviços'
    },
    home: {
      statsTitle: 'Números que Falam',
      statsYears: 'Anos de Experiência',
      statsPartners: 'Agências Parceiras',
      statsDestinations: 'Destinos',
      statsGroups: 'Pessoas transportadas por Ano',
      servicesTitle: 'Os Nossos Serviços',
      servicesSubtitle: 'Soluções completas para agências de viagens',
      productsTitle: 'Os Nossos Produtos',
      productsSubtitle: 'Uma vasta gama de opções de viagem',
      ctaTitle: 'Tem uma agência e quer ser nosso parceiro?',
      ctaSubtitle: 'Entre em contacto connosco e descubra como podemos ajudar a sua agência.',
      ctaButton: 'Contacte-nos'
    },
    about: {
      title: 'Sobre a 7x7 Travel',
      subtitle: 'A sua porta de entrada para experiências de viagem extraordinárias',
      missionTitle: 'A Nossa Missão',
      missionText: 'Proporcionar às agências de viagens parceiras serviços de excelência, soluções inovadoras e experiências de viagem únicas em Portugal e Espanha.',
      visionTitle: 'A Nossa Visão',
      visionText: 'Ser o operador turístico de referência na Península Ibérica, reconhecido pela qualidade, inovação e compromisso com os nossos parceiros.',
      valuesTitle: 'Os Nossos Valores',
      values: {
        excellence: { title: 'Excelência', desc: 'Compromisso com a qualidade em todos os serviços' },
        innovation: { title: 'Inovação', desc: 'Soluções tecnológicas de ponta' },
        partnership: { title: 'Parceria', desc: 'Relações duradouras com agências' },
        trust: { title: 'Confiança', desc: 'Transparência e integridade em tudo' }
      },
      historyTitle: 'A Nossa História',
      historyText: 'Fundada por profissionais na área de Gestão, TI e Turismo, a 7x7 Travel nasceu da paixão pelo turismo, tecnologia e da vontade de oferecer algo diferente ao mercado. Começámos como uma pequena empresa familiar e crescemos até nos tornarmos um operador turístico de referência na Península Ibérica.'
    },
    services: {
      title: 'Os Nossos Serviços',
      subtitle: 'Tudo o que a sua agência precisa para oferecer o melhor aos seus clientes',
      booking: {
        title: 'Booking Especializado',
        desc: 'Equipa de assessores especializados que tratam das suas reservas de forma rápida, ágil e com grande vocação de serviço.'
      },
      support: {
        title: 'Suporte 24/7',
        desc: 'Horário de funcionamento alargado, web ativa 24 horas e telefone de emergência de atenção ao cliente 24/365.'
      },
      commercial: {
        title: 'Equipa Comercial',
        desc: 'Equipa comercial dedicada, sempre disponível para ajudar com gestores em toda a Península Ibérica.'
      },
      technical: {
        title: 'Suporte Técnico',
        desc: 'Equipa IT própria especializada, aplicando a mais alta tecnologia ao serviço da sua agência.'
      },
      marketing: {
        title: 'Marketing & Design',
        desc: 'Departamento de marketing que desenha catálogos, ofertas personalizadas e materiais promocionais.'
      },
      quality: {
        title: 'Qualidade',
        desc: 'Equipa dedicada a testar a qualidade dos produtos e fazer seguimento exaustivo do serviço prestado.'
      }
    },
    products: {
      title: 'Os Nossos Produtos',
      subtitle: 'Uma vasta gama de opções para todos os tipos de viagem',
      groups: {
        title: 'Grupos',
        desc: 'Gestão personalizada e integral de grupos nacionais e internacionais com mais de 8 anos de experiência.',
        features: ['Orçamentos personalizados', 'Hotéis contratados diretamente', 'Guias profissionais', 'Transporte incluído']
      },
      hotels: {
        title: 'Hotéis',
        desc: 'Contratação direta em mais de 1.000 hotéis em Portugal e Espanha com os melhores preços.',
        features: ['Contratação direta', 'Melhores preços garantidos', 'Vasta seleção', 'Reserva online']
      },
      circuits: {
        title: 'Circuitos',
        desc: 'Circuitos culturais com partidas garantidas de autocarro, comboio ou avião.',
        features: ['Partidas garantidas', 'Guia acompanhante', 'Seguro incluído', 'Visitas culturais']
      },
      flights: {
        title: 'Voo + Hotel',
        desc: 'Pacotes completos para destinos de férias com preços fixos garantidos.',
        features: ['Preços fixos', 'Destinos de férias', 'Allotments garantidos', 'Pacotes completos']
      },
      incoming: {
        title: 'Incoming',
        desc: 'Serviços receptivos para grupos internacionais que visitam Portugal e Espanha.',
        features: ['Guias multilingues', 'Serviço à medida', 'Conhecimento local', 'Experiências autênticas']
      },
      outgoing: {
        title: 'Bus + Hotel',
        desc: 'Pacotes em autocarro para destinos de férias com preços fixos garantidos.',
        features: ['Preços fixos', 'Destinos de férias', 'Allotments garantidos', 'Pacotes completos']
      }
    },
    team: {
      title: 'A Nossa Equipa',
      subtitle: 'Profissionais dedicados ao seu serviço'
    },
    technology: {
      title: 'Tecnologia',
      subtitle: 'Inovação ao serviço do turismo',
      intro: 'Na 7x7 Travel, apostamos fortemente na tecnologia como diferencial competitivo. Desenvolvemos soluções inovadoras que aumentam a eficiência e rentabilidade das agências parceiras.',
      features: {
        api: {
          title: 'API de Integração',
          desc: 'Integração XML com os principais sistemas do mercado para reservas em tempo real.'
        },
        platform: {
          title: 'Plataforma B2B',
          desc: 'Plataforma web moderna e intuitiva para gestão de reservas 24/7.'
        },
        mobile: {
          title: 'App Mobile',
          desc: 'Aplicação móvel para acompanhamento de reservas e comunicação.'
        },
        analytics: {
          title: 'Analytics',
          desc: 'Relatórios detalhados e análise de dados para otimização de negócio.'
        }
      },
      statsTitle: 'Hub Técnico',
      stats: {
        requests: 'Pedidos XML/Ano',
        bookings: 'Reservas Online',
        uptime: 'Uptime'
      }
    },
    groupRequest: {
      title: 'Pedido de Orçamento',
      subtitle: 'Preencha o formulário para solicitar um orçamento para o seu grupo',
      tripSection: 'Tipo de Viagem',
      tripTypes: {
        students: 'Estudantes',
        corporate: 'Empresa',
        sports: 'Desportivo',
        congress: 'Congresso',
        other: 'Outros'
      },
      travelSection: 'Dados da Viagem',
      origin: 'Origem',
      destination: 'Destino',
      duration: 'Dias de Duração',
      people: 'Número de Pessoas',
      date: 'Data da Viagem',
      observations: 'Observações',
      contactSection: 'Dados de Contacto',
      agency: 'Agência de Viagens',
      firstName: 'Nome',
      lastName: 'Apelido',
      position: 'Cargo',
      address: 'Morada',
      postalCode: 'Código Postal',
      city: 'Localidade',
      email: 'Email',
      phone: 'Telefone',
      mobile: 'Telemóvel',
      privacy: 'Li e aceito a política de privacidade',
      submit: 'Enviar Pedido',
      submitting: 'A enviar...',
      success: 'Pedido enviado com sucesso! Iremos contactá-lo brevemente.',
      error: 'Ocorreu um erro ao enviar o pedido. Por favor, tente novamente.'
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aqui para ajudar',
      formTitle: 'Envie-nos uma mensagem',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      subject: 'Assunto',
      message: 'Mensagem',
      send: 'Enviar Mensagem',
      sending: 'A enviar...',
      success: 'Mensagem enviada com sucesso!',
      error: 'Ocorreu um erro. Por favor, tente novamente.',
      infoTitle: 'Informações de Contacto',
      addressLabel: 'Morada',
      phoneLabel: 'Telefone',
      emergencyLabel: 'Assistência 24H',
      emailLabel: 'Email'
    },
    footer: {
      description: 'Operador turístico especializado em viagens para Portugal e Espanha.',
      quickLinks: 'Links Rápidos',
      contactInfo: 'Contactos',
      address: 'Rua da Estrada Nova, 203',
      city: '4435-234 Rio Tinto | Portugal',
      phone: 'Telefone',
      emergency: 'Assistência 24H',
      rights: 'Todos os direitos reservados.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      products: 'Products',
      team: 'Team',
      technology: 'Technology',
      groupRequest: 'Group Request',
      contact: 'Contact',
      agencies: 'Agencies'
    },
    hero: {
      title: 'Your Operator for Portugal and Spanish Coasts',
      subtitle: 'Specialized tour operator creating memorable travel experiences for travel agencies.',
      cta: 'Request Quote',
      ctaSecondary: 'Discover Services'
    },
    home: {
      statsTitle: 'Numbers That Speak',
      statsYears: 'Years of Experience',
      statsPartners: 'Partner Agencies',
      statsDestinations: 'Destinations',
      statsGroups: 'Groups per Year',
      servicesTitle: 'Our Services',
      servicesSubtitle: 'Complete solutions for travel agencies',
      productsTitle: 'Our Products',
      productsSubtitle: 'A wide range of travel options',
      ctaTitle: 'Have an agency and want to be our partner?',
      ctaSubtitle: 'Get in touch with us and discover how we can help your agency.',
      ctaButton: 'Contact Us'
    },
    about: {
      title: 'About 7x7 Travel',
      subtitle: 'Your gateway to extraordinary travel experiences',
      missionTitle: 'Our Mission',
      missionText: 'To provide partner travel agencies with excellent services, innovative solutions, and unique travel experiences in Portugal and Spain.',
      visionTitle: 'Our Vision',
      visionText: 'To be the reference tour operator in the Iberian Peninsula, recognized for quality, innovation, and commitment to our partners.',
      valuesTitle: 'Our Values',
      values: {
        excellence: { title: 'Excellence', desc: 'Commitment to quality in all services' },
        innovation: { title: 'Innovation', desc: 'Cutting-edge technological solutions' },
        partnership: { title: 'Partnership', desc: 'Long-lasting relationships with agencies' },
        trust: { title: 'Trust', desc: 'Transparency and integrity in everything' }
      },
      historyTitle: 'Our History',
      historyText: 'Founded over 8 years ago, 7x7 Travel was born from a passion for tourism and a desire to offer something different to the market. We started as a small family business and grew to become a reference tour operator in the Iberian Peninsula.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Everything your agency needs to offer the best to your clients',
      booking: {
        title: 'Specialized Booking',
        desc: 'Team of specialized advisors who handle your reservations quickly, efficiently, and with great service dedication.'
      },
      support: {
        title: '24/7 Support',
        desc: 'Extended operating hours, 24-hour active website, and emergency customer service phone line 24/365.'
      },
      commercial: {
        title: 'Commercial Team',
        desc: 'Dedicated commercial team, always available to help with managers throughout the Iberian Peninsula.'
      },
      technical: {
        title: 'Technical Support',
        desc: 'Specialized in-house IT team, applying the highest technology to serve your agency.'
      },
      marketing: {
        title: 'Marketing & Design',
        desc: 'Marketing department that designs catalogs, personalized offers, and promotional materials.'
      },
      quality: {
        title: 'Quality',
        desc: 'Team dedicated to testing product quality and thorough monitoring of service provided.'
      }
    },
    products: {
      title: 'Our Products',
      subtitle: 'A wide range of options for all types of travel',
      groups: {
        title: 'Groups',
        desc: 'Personalized and comprehensive management of national and international groups with over 8 years of experience.',
        features: ['Custom quotes', 'Directly contracted hotels', 'Professional guides', 'Transport included']
      },
      hotels: {
        title: 'Hotels',
        desc: 'Direct contracting with over 1,000 hotels in Portugal and Spain at the best prices.',
        features: ['Direct contracting', 'Best prices guaranteed', 'Wide selection', 'Online booking']
      },
      circuits: {
        title: 'Circuits',
        desc: 'Cultural circuits with guaranteed departures by bus, train, or plane.',
        features: ['Guaranteed departures', 'Accompanying guide', 'Insurance included', 'Cultural visits']
      },
      flights: {
        title: 'Flight + Hotel',
        desc: 'Complete packages to holiday destinations with guaranteed fixed prices.',
        features: ['Fixed prices', 'Holiday destinations', 'Guaranteed allotments', 'Complete packages']
      },
      incoming: {
        title: 'Incoming',
        desc: 'Receptive services for international groups visiting Portugal and Spain.',
        features: ['Multilingual guides', 'Tailored service', 'Local knowledge', 'Authentic experiences']
      },
      outgoing: {
        title: 'Bus + Hotel',
        desc: 'Bus packages to holiday destinations with guaranteed fixed prices.',
        features: ['Fixed prices', 'Holiday destinations', 'Guaranteed allotments', 'Complete packages']
      }
    },
    team: {
      title: 'Our Team',
      subtitle: 'Dedicated professionals at your service'
    },
    technology: {
      title: 'Technology',
      subtitle: 'Innovation at the service of tourism',
      intro: 'At 7x7 Travel, we strongly invest in technology as a competitive differentiator. We develop innovative solutions that increase the efficiency and profitability of partner agencies.',
      features: {
        api: {
          title: 'Integration API',
          desc: 'XML integration with major market systems for real-time bookings.'
        },
        platform: {
          title: 'B2B Platform',
          desc: 'Modern and intuitive web platform for 24/7 booking management.'
        },
        mobile: {
          title: 'Mobile App',
          desc: 'Mobile application for booking tracking and communication.'
        },
        analytics: {
          title: 'Analytics',
          desc: 'Detailed reports and data analysis for business optimization.'
        }
      },
      statsTitle: 'Technical Hub',
      stats: {
        requests: 'XML Requests/Year',
        bookings: 'Online Bookings',
        uptime: 'Uptime'
      }
    },
    groupRequest: {
      title: 'Quote Request',
      subtitle: 'Fill out the form to request a quote for your group',
      tripSection: 'Trip Type',
      tripTypes: {
        students: 'Students',
        corporate: 'Corporate',
        sports: 'Sports',
        congress: 'Congress',
        other: 'Other'
      },
      travelSection: 'Travel Details',
      origin: 'Origin',
      destination: 'Destination',
      duration: 'Duration (Days)',
      people: 'Number of People',
      date: 'Travel Date',
      observations: 'Observations',
      contactSection: 'Contact Details',
      agency: 'Travel Agency',
      firstName: 'First Name',
      lastName: 'Last Name',
      position: 'Position',
      address: 'Address',
      postalCode: 'Postal Code',
      city: 'City',
      email: 'Email',
      phone: 'Phone',
      mobile: 'Mobile',
      privacy: 'I have read and accept the privacy policy',
      submit: 'Submit Request',
      submitting: 'Submitting...',
      success: 'Request submitted successfully! We will contact you shortly.',
      error: 'An error occurred while submitting the request. Please try again.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'We are here to help',
      formTitle: 'Send us a message',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'An error occurred. Please try again.',
      infoTitle: 'Contact Information',
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      emergencyLabel: '24H Assistance',
      emailLabel: 'Email'
    },
    footer: {
      description: 'Tour operator specialized in travel to Portugal and Spain.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact',
      address: 'Rua da Estrada Nova, 203',
      city: '4435-234 Rio Tinto | Portugal',
      phone: 'Phone',
      emergency: '24H Assistance',
      rights: 'All rights reserved.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      services: 'Servicios',
      products: 'Productos',
      team: 'Equipo',
      technology: 'Tecnología',
      groupRequest: 'Solicitud Grupos',
      contact: 'Contacto',
      agencies: 'Agencias'
    },
    hero: {
      title: 'Su Operador para Portugal y Costas Españolas',
      subtitle: 'Operador turístico especializado en crear experiencias de viaje memorables para agencias de viajes.',
      cta: 'Solicitar Presupuesto',
      ctaSecondary: 'Conocer Servicios'
    },
    home: {
      statsTitle: 'Números que Hablan',
      statsYears: 'Años de Experiencia',
      statsPartners: 'Agencias Asociadas',
      statsDestinations: 'Destinos',
      statsGroups: 'Grupos por Año',
      servicesTitle: 'Nuestros Servicios',
      servicesSubtitle: 'Soluciones completas para agencias de viajes',
      productsTitle: 'Nuestros Productos',
      productsSubtitle: 'Una amplia gama de opciones de viaje',
      ctaTitle: '¿Tiene una agencia y quiere ser nuestro socio?',
      ctaSubtitle: 'Póngase en contacto con nosotros y descubra cómo podemos ayudar a su agencia.',
      ctaButton: 'Contáctenos'
    },
    about: {
      title: 'Sobre 7x7 Travel',
      subtitle: 'Su puerta de entrada a experiencias de viaje extraordinarias',
      missionTitle: 'Nuestra Misión',
      missionText: 'Proporcionar a las agencias de viajes asociadas servicios de excelencia, soluciones innovadoras y experiencias de viaje únicas en Portugal y España.',
      visionTitle: 'Nuestra Visión',
      visionText: 'Ser el operador turístico de referencia en la Península Ibérica, reconocido por la calidad, innovación y compromiso con nuestros socios.',
      valuesTitle: 'Nuestros Valores',
      values: {
        excellence: { title: 'Excelencia', desc: 'Compromiso con la calidad en todos los servicios' },
        innovation: { title: 'Innovación', desc: 'Soluciones tecnológicas de vanguardia' },
        partnership: { title: 'Colaboración', desc: 'Relaciones duraderas con agencias' },
        trust: { title: 'Confianza', desc: 'Transparencia e integridad en todo' }
      },
      historyTitle: 'Nuestra Historia',
      historyText: 'Fundada hace más de 8 años, 7x7 Travel nació de la pasión por el turismo y el deseo de ofrecer algo diferente al mercado. Comenzamos como una pequeña empresa familiar y crecimos hasta convertirnos en un operador turístico de referencia en la Península Ibérica.'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Todo lo que su agencia necesita para ofrecer lo mejor a sus clientes',
      booking: {
        title: 'Reservas Especializadas',
        desc: 'Equipo de asesores especializados que gestionan sus reservas de forma rápida, ágil y con gran vocación de servicio.'
      },
      support: {
        title: 'Soporte 24/7',
        desc: 'Horario de funcionamiento ampliado, web activa 24 horas y teléfono de emergencia de atención al cliente 24/365.'
      },
      commercial: {
        title: 'Equipo Comercial',
        desc: 'Equipo comercial dedicado, siempre disponible para ayudar con gestores en toda la Península Ibérica.'
      },
      technical: {
        title: 'Soporte Técnico',
        desc: 'Equipo IT propio especializado, aplicando la más alta tecnología al servicio de su agencia.'
      },
      marketing: {
        title: 'Marketing y Diseño',
        desc: 'Departamento de marketing que diseña catálogos, ofertas personalizadas y materiales promocionales.'
      },
      quality: {
        title: 'Calidad',
        desc: 'Equipo dedicado a probar la calidad de los productos y hacer un seguimiento exhaustivo del servicio prestado.'
      }
    },
    products: {
      title: 'Nuestros Productos',
      subtitle: 'Una amplia gama de opciones para todo tipo de viajes',
      groups: {
        title: 'Grupos',
        desc: 'Gestión personalizada e integral de grupos nacionales e internacionales con más de 8 años de experiencia.',
        features: ['Presupuestos personalizados', 'Hoteles contratados directamente', 'Guías profesionales', 'Transporte incluido']
      },
      hotels: {
        title: 'Hoteles',
        desc: 'Contratación directa en más de 1.000 hoteles en Portugal y España a los mejores precios.',
        features: ['Contratación directa', 'Mejores precios garantizados', 'Amplia selección', 'Reserva online']
      },
      circuits: {
        title: 'Circuitos',
        desc: 'Circuitos culturales con salidas garantizadas en autobús, tren o avión.',
        features: ['Salidas garantizadas', 'Guía acompañante', 'Seguro incluido', 'Visitas culturales']
      },
      flights: {
        title: 'Vuelo + Hotel',
        desc: 'Paquetes completos a destinos de vacaciones con precios fijos garantizados.',
        features: ['Precios fijos', 'Destinos de vacaciones', 'Allotments garantizados', 'Paquetes completos']
      },
      incoming: {
        title: 'Incoming',
        desc: 'Servicios receptivos para grupos internacionales que visitan Portugal y España.',
        features: ['Guías multilingües', 'Servicio a medida', 'Conocimiento local', 'Experiencias auténticas']
      },
      outgoing: {
        title: 'Bus + Hotel',
        desc: 'Paquetes en autobús a destinos de vacaciones con precios fijos garantizados.',
        features: ['Precios fijos', 'Destinos de vacaciones', 'Allotments garantizados', 'Paquetes completos']
      }
    },
    team: {
      title: 'Nuestro Equipo',
      subtitle: 'Profesionales dedicados a su servicio'
    },
    technology: {
      title: 'Tecnología',
      subtitle: 'Innovación al servicio del turismo',
      intro: 'En 7x7 Travel, apostamos fuertemente por la tecnología como diferencial competitivo. Desarrollamos soluciones innovadoras que aumentan la eficiencia y rentabilidad de las agencias asociadas.',
      features: {
        api: {
          title: 'API de Integración',
          desc: 'Integración XML con los principales sistemas del mercado para reservas en tiempo real.'
        },
        platform: {
          title: 'Plataforma B2B',
          desc: 'Plataforma web moderna e intuitiva para gestión de reservas 24/7.'
        },
        mobile: {
          title: 'App Móvil',
          desc: 'Aplicación móvil para seguimiento de reservas y comunicación.'
        },
        analytics: {
          title: 'Analytics',
          desc: 'Informes detallados y análisis de datos para optimización de negocio.'
        }
      },
      statsTitle: 'Hub Técnico',
      stats: {
        requests: 'Peticiones XML/Año',
        bookings: 'Reservas Online',
        uptime: 'Uptime'
      }
    },
    groupRequest: {
      title: 'Solicitud de Presupuesto',
      subtitle: 'Rellene el formulario para solicitar un presupuesto para su grupo',
      tripSection: 'Tipo de Viaje',
      tripTypes: {
        students: 'Estudiantes',
        corporate: 'Empresa',
        sports: 'Deportivo',
        congress: 'Congreso',
        other: 'Otros'
      },
      travelSection: 'Datos del Viaje',
      origin: 'Origen',
      destination: 'Destino',
      duration: 'Duración (Días)',
      people: 'Número de Personas',
      date: 'Fecha del Viaje',
      observations: 'Observaciones',
      contactSection: 'Datos de Contacto',
      agency: 'Agencia de Viajes',
      firstName: 'Nombre',
      lastName: 'Apellido',
      position: 'Cargo',
      address: 'Dirección',
      postalCode: 'Código Postal',
      city: 'Localidad',
      email: 'Email',
      phone: 'Teléfono',
      mobile: 'Móvil',
      privacy: 'He leído y acepto la política de privacidad',
      submit: 'Enviar Solicitud',
      submitting: 'Enviando...',
      success: '¡Solicitud enviada con éxito! Le contactaremos en breve.',
      error: 'Se produjo un error al enviar la solicitud. Por favor, inténtelo de nuevo.'
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aquí para ayudar',
      formTitle: 'Envíenos un mensaje',
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      sending: 'Enviando...',
      success: '¡Mensaje enviado con éxito!',
      error: 'Se produjo un error. Por favor, inténtelo de nuevo.',
      infoTitle: 'Información de Contacto',
      addressLabel: 'Dirección',
      phoneLabel: 'Teléfono',
      emergencyLabel: 'Asistencia 24H',
      emailLabel: 'Email'
    },
    footer: {
      description: 'Operador turístico especializado en viajes a Portugal y España.',
      quickLinks: 'Enlaces Rápidos',
      contactInfo: 'Contacto',
      address: 'Rua da Estrada Nova, 203',
      city: '4435-234 Rio Tinto | Portugal',
      phone: 'Teléfono',
      emergency: 'Asistencia 24H',
      rights: 'Todos los derechos reservados.'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      return key;
    }
  }
  return result;
};
